import * as React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Hero from "../components/hero";
import Articles from "../components/articles";
import NewsletterForm from "../components/newsletter-form";
import { useIntl } from "react-intl";

const JournalPage = ({ data }) => {
  const articles = data.articles.nodes;
  const { formatMessage } = useIntl();

  return (
    <Layout>
      <Seo title="Magazine" />
      <Hero title="Magazine" variant="journal" />
      <div className="container">
        <div className="magazine-newsletter">
          <span
            dangerouslySetInnerHTML={{
              __html: formatMessage({
                id: "beyondBikingNewsletter",
              }),
            }}
          />
          <NewsletterForm listId={26} />
        </div>
      </div>
      <Articles articles={articles} />
    </Layout>
  );
};

export default JournalPage;

export const query = graphql`
  query ($locale: String!) {
    articles: allContentfulArticle(
      filter: { node_locale: { eq: $locale } }
      sort: { fields: publishedAt, order: DESC }
    ) {
      nodes {
        contentful_id
        publishedAt
        title
        slug
        featuredImage {
          description
          title
          gatsbyImageData(layout: FULL_WIDTH)
        }
        publishedAt
        excerpt {
          excerpt
        }
      }
    }

    translations: contentfulTranslations(node_locale: { eq: $locale }) {
      translations {
        key
        value
      }
    }
  }
`;
